// extracted by mini-css-extract-plugin
module.exports = {"ProfileStat":"profile-stat_ProfileStat__E2A_-"};